import {
    FETCH_SCHEMES_PLAN_OPTION_REQUEST,
    FETCH_SCHEMES_PLAN_OPTION_SUCCESS,
    FETCH_SCHEMES_PLAN_OPTION_FAILURE,
  } from "./FetchMedSchemePlanOptionsTypes";
  
  const initialState = {
    loading: false,
    schemesPlanOptions: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SCHEMES_PLAN_OPTION_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_SCHEMES_PLAN_OPTION_SUCCESS:
        return {
          loading: false,
          schemesPlanOptions: action.payload,
          error: "",
        };
      case FETCH_SCHEMES_PLAN_OPTION_FAILURE:
        return {
          loading: false,
          schemesPlanOptions: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  